var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 74,
    viewBox: "0 0 484 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7760_7339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7760_7339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 483,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.344 2H1.6543V74H483.344V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7760_7339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5394 2.25391H85.9746L61.67 16.2324H46.5394C41.3575 16.2324 34.022 17.1092 30.0712 19.4855C26.1199 21.7963 23.043 24.9988 20.8408 29.092C18.7033 33.1855 17.6348 37.7741 17.6348 42.8581C17.6348 48.2056 19.3191 52.4643 22.6871 55.6332C26.1199 58.7365 31.0098 60.2883 37.3577 60.2883C41.3733 60.2883 45.1305 59.4627 48.6277 57.8124L52.6114 37.0154H66.9903L61.3557 65.537C57.9222 68.2439 53.9393 70.3234 49.4048 71.7759C44.8711 73.2288 40.1752 73.9545 35.3174 73.9545C28.516 73.9545 22.5899 72.7006 17.5375 70.1916C12.4854 67.6823 8.5667 64.1501 5.78158 59.5943C3.06121 55.0391 1.70117 49.7902 1.70117 43.8483C1.70117 35.991 3.48245 28.894 7.04468 22.5557C10.6072 16.2177 15.6267 11.2661 22.1042 7.70071C28.5813 4.06972 38.119 2.25391 46.5394 2.25391Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9726 12.6838L96.4304 2L83.1534 74H67.666L78.9726 12.6838Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.491 2L150.883 73.9958H137.955L112.586 28.9467L104.033 73.9958H88.4805L102.089 2H115.114L140.483 47.1513L148.939 2H164.491Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.887 58.568H180.205L171.361 73.9958H154.549L198.573 2H214.122L230.837 73.9958H215.093L211.887 58.568ZM209.263 45.9172L203.529 18.1478L187.494 45.9172H209.263Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.184 71.6246C242.112 73.0798 247.268 73.8069 252.65 73.8069C258.941 73.8069 264.453 72.8483 269.187 70.9308C273.922 68.9473 277.586 66.2028 280.179 62.6985C282.774 59.1282 284.073 54.9626 284.073 50.2016C284.073 46.3667 283.065 43.2927 281.056 40.978C279.111 38.5977 276.742 36.8127 273.954 35.6223C271.166 34.3661 267.599 33.1424 263.254 31.9528C260.206 31.0928 257.838 30.366 256.153 29.7708C254.467 29.1094 253.072 28.2829 251.97 27.2908C250.868 26.2335 250.316 24.9439 250.316 23.4231C250.316 20.9103 251.613 18.8606 254.207 17.2737C256.801 15.6871 260.336 14.8936 264.81 14.8936C268.247 14.8936 271.554 15.3564 274.732 16.2817C274.754 16.2876 274.774 16.2932 274.796 16.2992L277.409 3.26779C273.709 2.42249 269.801 2 265.686 2C259.46 2 253.98 2.95865 249.246 4.87624C244.576 6.79387 240.945 9.53772 238.351 13.1081C235.822 16.6785 234.557 20.8111 234.557 25.5059C234.557 29.5391 235.562 32.7793 237.573 35.2253C239.648 37.6716 242.08 39.523 244.869 40.78C247.657 41.9693 251.257 43.2264 255.666 44.5483C260.076 45.8048 263.286 46.9949 265.297 48.119C267.307 49.1769 268.312 50.7307 268.312 52.7806C268.312 55.2933 267.048 57.2768 264.519 58.7318C261.989 60.1862 258.552 60.9132 254.207 60.9132C250.121 60.9132 246.133 60.2855 242.242 59.0285C238.553 57.8375 235.214 56.1714 232.225 54.03L236.408 71.3908C236.664 71.4695 236.922 71.5475 237.184 71.6246Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.557 15.576H302.314L291.338 73.9958H307.074L318.148 15.576H339.809L345.432 15.5223L334.386 73.9958H387.039L389.658 60.6252H352.552L355.661 43.9633H387.327L389.757 31.0039H358.186L361.1 15.3708L407.691 15.5223L396.645 73.9958H449.296L451.92 60.6252H414.811L417.917 43.9633H449.586L452.015 31.0039H420.442L423.359 15.3708H459.005L483.31 2H410.245H283.178L280.557 15.576Z",
    fill: "#F8F8F8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7760_7339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481.69,
    height: 72,
    fill: "white",
    transform: "translate(1.6543 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.a0a0c3c351eb2d5566ca966ee9a9de3b.svg";
export { ForwardRef as ReactComponent };